import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const AfterNaverSignup = () => {
  const location = useLocation();
  const [token, setToken] = useState(null);

  const getNaverToken = () => {
    if (!location.hash) return;
    const token = location.hash.split("=")[1].split("&")[0];
    console.log("token", token);
    setToken(token);
  };

  useEffect(() => {
    // initializeNaverLogin();
    getNaverToken();
  }, []);
  return <div>AfterNaverSignup</div>;
};

export default AfterNaverSignup;
//https://prism-a6a80.firebaseapp.com/
//after-naver-signup#
//access_token=AAAAOoVf1NWTxrHkTMO6ZYR_piAcJ0NDny7_4T9bpLHickNxtprsZ-NmNmdRT235XojymnPHck_bCrfFvuDDr8WZLDo&state=e98d0cb0-cfb6-4fec-bf15-f0d664ffc454&
//token_type=bearer&
//expires_in=3600

//https://prism-a6a80.firebaseapp.com/after-naver-signup#access_token=AAAAOoVf1NWTxrHkTMO6ZYR_piAcJ0NDny7_4T9bpLHickNxtprsZ-NmNmdRT235XojymnPHck_bCrfFvuDDr8WZLDo&state=e98d0cb0-cfb6-4fec-bf15-f0d664ffc454&token_type=bearer&expires_in=3600
